export const ANALYTICS_TRANSPORT = {
  SEGMENT: 'segment',
  MIXPANEL: 'mixpanel',
} as const;
